import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "price" ]

  connect() {
    if (document.body.getAttribute("data-action") == "edit" || document.body.getAttribute("data-action") == "update") {
      if (this.priceTarget.options[this.priceTarget.selectedIndex].textContent == "Recicláveis") {
        document.getElementById("priceBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("priceBlock").classList.add("is-display-none")
      }
    }
  }

  changeResidueType(event) {
    if (event.target.selectedOptions[0].textContent == "Recicláveis") {
      document.getElementById("priceBlock").classList.remove("is-display-none")
    } else {
      document.getElementById("priceBlock").classList.add("is-display-none")
    }
  }
}
